package com.ives.components.notifier;

import js.Browser;
import js.html.DivElement;

import com.er453r.hxcompo.Component;

import haxe.Timer;

class Notifier extends Component{
	public static var instance:Notifier;

	public function new(){
		if(instance != null)
			throw "Notifier";

		instance = this;
	}

	public static function info(message:String){
		var div:DivElement = Browser.document.createDivElement();

		div.classList.add("info");

		div.innerHTML = message;

		instance.viewElement.insertBefore(div, instance.viewElement.firstChild);
	}
}
